var exports = {
  "az": "Box__swapE6",
  "wb": "Box_inlineAvatars__OXEjSV",
  "Lq": "loading__brMIzi",
  "wy": "Box_1__gSBsk4",
  "pv": "Box_2__t0-6Om",
  "yo": "hovered__R6nb3M",
};

module.exports = exports;
